import { render } from "./PatientsDatatableFormMPhone.vue?vue&type=template&id=183bd0d7&scoped=true"
import script from "./PatientsDatatableFormMPhone.vue?vue&type=script&lang=js"
export * from "./PatientsDatatableFormMPhone.vue?vue&type=script&lang=js"

import "./PatientsDatatableFormMPhone.vue?vue&type=style&index=0&id=183bd0d7&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-183bd0d7"]])

export default __exports__